module.exports = __webpack_public_path__ + "img/banner2.44cd0f07.jpg";